import { Grid, Typography } from "@mui/material";
import Chips from "./Chips";
import { Fragment, useContext } from "react";
import { WorkTitle } from "../../orders/orderAPI";
import { useAppSelector } from "../../../app/hooks";
import { groupWorkTitles, WorkTitleGroups } from "../LocalizedGroups";
import { AccessRightContext } from "../../user/AccessRightProvider";

type FormProps = {
  workTitles: WorkTitle[];
  removeWorkTitleCallback: (workTitleId: string) => void;
};
const WorkTitleRows = ({ workTitles, removeWorkTitleCallback }: FormProps) => {
  const localizedWorkTitleIds = useAppSelector(
    (state) => state.localized?.workTitle,
  );
  const localizedFieldOfWorkIds = useAppSelector(
    (state) => state.localized?.fieldOfWork,
  );
  const { canEditTalentProfile } = useContext(AccessRightContext);

  let localizedWorkTitleGroups: WorkTitleGroups = groupWorkTitles(workTitles, {
    workTitle: localizedWorkTitleIds,
    fieldOfWork: localizedFieldOfWorkIds,
  });

  // Sorting the entries of localizedWorkTitleGroups based on the keys
  localizedWorkTitleGroups = Object.fromEntries(
    Object.entries(localizedWorkTitleGroups).sort(([a], [b]) =>
      a && b ? a.localeCompare(b) : 0,
    ),
  ) as WorkTitleGroups;

  return (
    <>
      <Grid container columnSpacing={2} rowSpacing={2}>
        {Object.entries(localizedWorkTitleGroups).map(
          ([localizedFieldOfWork, value]) => (
            <Fragment key={localizedFieldOfWork}>
              <Grid
                item
                container
                xs={3}
                justifyContent="flex-end"
                alignItems="center"
              >
                <Typography textAlign="end" variant="secondary">
                  {localizedFieldOfWork}
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Chips
                  workTitles={value.sort((a, b) => {
                    // Use name if available; otherwise, use id for comparison
                    const nameA = a.name ?? a.id;
                    const nameB = b.name ?? b.id;
                    return nameA.localeCompare(nameB);
                  })}
                  onDelete={
                    (canEditTalentProfile && removeWorkTitleCallback) ||
                    undefined
                  }
                />
              </Grid>
            </Fragment>
          ),
        )}
      </Grid>
    </>
  );
};

export default WorkTitleRows;
